

        jQuery(function() {
            var $module = jQuery('#m-1526060251906').children('.module');
            var btnLabel = $module.attr('data-btnlabel');
            $module.gfSocialShare({
                btnLabel: btnLabel
            });
        });
    
        jQuery(function() {
            var $module = jQuery('#m-1526061080090').children('.module');

        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1526061821431').children('.module');

        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1526061824627').children('.module');

        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526062530986').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526062530986-child1').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1526062530986-child1-0').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1526062530986-child1-1').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526062530986-child2').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1526062530986-child2-0').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1526062530986-child2-1').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526062530986-child3').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1526062530986-child3-0').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1526062530986-child3-1').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526062798005').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526062798005-child1').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1526062798005-child1-0').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1526062798005-child1-1').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526062798005-child2').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1526062798005-child2-0').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1526062798005-child2-1').children('.module');
        }); 
    
        jQuery(function() {
          var $module = jQuery('#m-1526062798005-child3').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1526062798005-child3-0').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1526062798005-child3-1').children('.module');
        }); 
    